<h2 mat-dialog-title>Generate Product QR Batch</h2>

<form [formGroup]="BatchForm" (ngSubmit)="onSubmit()">
    <mat-dialog-content class="dialog-form">
        <mat-form-field appearance="outline">
            <mat-label>Batch Name</mat-label>
            <input matInput type="text" formControlName="batch_name">
            <mat-error *ngIf="BatchForm.get('batch_name')?.invalid">Batch name is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Product</mat-label>
            <mat-select formControlName="product_id">
                <mat-option *ngFor="let product of products" [value]="product.id">
                    {{product.product_title}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="BatchForm.get('product_id')?.invalid">Product is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Assigned to</mat-label>
            <mat-select formControlName="assigned_user_id">
                <mat-option *ngFor="let user of stallUsers" [value]="user.id">
                    {{user.name}} - {{user.mobile}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="BatchForm.get('assigned_user_id')?.invalid">Assigned user is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Quantity</mat-label>
            <input matInput type="number" formControlName="quantity" min="1" max="1000">
            <mat-error *ngIf="BatchForm.get('quantity')?.invalid">Enter 1 to 1000</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Points per QR</mat-label>
            <input matInput type="number" formControlName="points_per_scan" min="1">
            <mat-error *ngIf="BatchForm.get('points_per_scan')?.invalid">Points are required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Expiry date</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="expiry_date">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="BatchForm.get('expiry_date')?.invalid">Expiry date is required</mat-error>
        </mat-form-field>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button type="button" mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary" type="submit">Generate</button>
    </mat-dialog-actions>
</form>